// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2hQRL","image":"Header_image__1GrmP","name":"Header_name__3jO6_","info":"Header_info__3_-t8","infoRow":"Header_infoRow__ZuhpM"};